import { useState } from 'react';
import { useLocation } from 'react-router-dom';

const KEY = 'jh_consent';

// Shown to visitors on the Spanish section or in a European time zone.
// The Facebook Pixel only loads after "Accept".
export default function CookieConsent() {
  const { pathname } = useLocation();
  const [choice, setChoice] = useState(() => localStorage.getItem(KEY));
  const needs = window.jhNeedsConsent ? window.jhNeedsConsent(pathname) : pathname.startsWith('/es');
  if (choice || !needs) return null;

  const es = pathname.startsWith('/es') || pathname.startsWith('/mx');
  const decide = (v) => {
    localStorage.setItem(KEY, v);
    setChoice(v);
    if (v === 'granted' && window.jhLoadFbPixel) window.jhLoadFbPixel();
  };

  return (
    <div role="dialog" aria-label={es ? 'Consentimiento de cookies' : 'Cookie consent'}
      className="fixed left-4 right-20 bottom-4 md:left-6 md:right-auto md:max-w-md z-50 rounded-2xl border border-border/50 bg-card/95 backdrop-blur-xl p-5 shadow-lg">
      <p className="text-sm text-muted-foreground font-inter leading-relaxed mb-4">
        {es
          ? 'Usamos cookies de analítica y publicidad (como el píxel de Meta) solo si las aceptas. Las cookies técnicas necesarias siempre están activas.'
          : 'We use analytics and advertising cookies (such as the Meta Pixel) only if you accept. Strictly necessary cookies are always on.'}
      </p>
      <div className="flex gap-3">
        <button type="button" onClick={() => decide('granted')}
          className="px-5 py-2.5 bg-primary text-primary-foreground font-inter font-semibold text-xs tracking-wider uppercase rounded-lg hover:bg-primary/90 transition-all">
          {es ? 'Aceptar' : 'Accept'}
        </button>
        <button type="button" onClick={() => decide('denied')}
          className="px-5 py-2.5 border border-primary/40 text-primary font-inter font-semibold text-xs tracking-wider uppercase rounded-lg hover:bg-primary/10 transition-all">
          {es ? 'Rechazar' : 'Reject'}
        </button>
      </div>
    </div>
  );
}